import noop from 'lodash/noop';
import { instanceOf, bool } from 'prop-types';

import { rem } from '@blueprint/ui';

import { Typography, Text } from 'components/blueprint';
import { useSafeLabel } from 'hooks';

import { ActionLabelPill } from '../ActionPillWrapper';
import { ChatbotBaseReplyBox } from '../ChatbotBaseReplyBox';
import messages from './messages';

export const SKIP_FEEDBACK_ENTRY = '_ics_no_reason_given_';

export const PromoteInputFeedback = ({
  datetime,
  isFeedbackEnable,
  onSkipFeedback,
}) => {
  const safeLabel = useSafeLabel();

  return (
    <ChatbotBaseReplyBox datetime={datetime}>
      <Typography as="p" lineHeight={rem(20)}>
        {safeLabel(messages.promotion)}
      </Typography>
      <ActionLabelPill
        disabled={!isFeedbackEnable}
        alignSelf="start"
        marginTop={rem(12)}
        onClick={
          isFeedbackEnable
            ? (event) => {
                event.preventDefault();
                onSkipFeedback(SKIP_FEEDBACK_ENTRY);
              }
            : noop
        }
      >
        <Text>{safeLabel(messages.skipThisAction)}</Text>
      </ActionLabelPill>
    </ChatbotBaseReplyBox>
  );
};

PromoteInputFeedback.propTypes = {
  /**
   * Datetime of the reply
   */
  datetime: instanceOf(Date).isRequired,
  /**
   * Whether to enable feedback action at the reply
   */
  isFeedbackEnable: bool,
};
